export default __webpack_public_path__ + "static/media/101.559fa4f4.jpg";